<template>
  <div>
    <Header :image="storeInfo.image">
      {{ storeInfo.name }}
    </Header>
    <main id="#main">
      <h2 class="c-level2">
        <span>
          ご予約完了
        </span>
      </h2>
      <div class="c-card-default">
        <p>
            予約申込が完了しました。<br>
            確認のメールをお送りしましたので、予約内容を必ずご確認ください。<br>
            また、予約の変更は、直接施設へご連絡ください。
        </p>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { mapState, mapActions } from 'vuex'
import { Mixin } from '@/mixin'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  head: {
    title: function () {
      return {
        inner: this.storeInfo.name,
        separator: '|',
        complement: '予約完了'
      }
    }
  },
  computed: {
    ...mapState({
      storeInfo: 'storeInfo'
    })
  },
  beforeRouteEnter (route, redirect, next) {
    next(async vm => {
      const promises = []
      vm.$store.commit('SET_LOADING', true)
      promises.push(vm.$store.dispatch('LOAD_STORE_INFO', { storeid: route.params.storeid }))
      await Promise.all(promises).then(function () {
        vm.$emit('updateHead')
        vm.$store.commit('SET_LOADING', false)
      }).catch(function (error) {
        vm.$store.commit('SET_LOADING', false)
        alert(error.message)
      })
    })
  },
  mixins: [Mixin],
  methods: {
    ...mapActions(['LOAD_STORE_INFO', 'LOAD_MENU_INFO'])
  }
}
</script>
